import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-virtual-numeric-keyboard',
  templateUrl: './virtual-numeric-keyboard.component.html',
  styleUrls: ['./virtual-numeric-keyboard.component.scss']
})
export class VirtualNumericKeyboardComponent {
  // Defines the numeric keys split into rows (3 keys per row)
  numberRows: string[][] = [
    ['1', '2', '3'],
    ['4', '5', '6'],
    ['7', '8', '9']
  ];

  // Defines the alphabetic keys split into rows
  alphaRows: string[][] = [
    ['A', 'B', 'C', 'D', 'E'],
    ['F', 'G', 'H', 'I', 'J'],
    ['K', 'L', 'M', 'N', 'O'],
    ['P', 'Q', 'R', 'S', 'T'],
    ['U', 'V', 'W', 'X', 'Y', 'Z']
  ];

  // Event emitter to send the pressed key upwards
  @Output() keyPress = new EventEmitter<string>();

  /**
   * Handles key presses, emitting the pressed key
   * @param key - The key that was pressed
   */
  onKeyPress(key: string): void {
    this.keyPress.emit(key);
  }
}
